import React, { useState, useEffect } from 'react';
import './sensordata.css';
import Utility from '../../helpers/Utility';
import upArrow from '../../assets/up.png';
import downArrow from '../../assets/down.png'
import {
  Modal,
  Card,
  Accordion,
  Row,
  Col
} from 'react-bootstrap';
import SensorService from '../../services/sensorService';
import toast from '../toast';
import moment from 'moment'
import userService from '../../services/userService';
import pinConfigurationService from '../../services/pinConfigurationService';
import temperatureService from '../../services/temperatureService';

export interface SensorProps {
  show: boolean
  closeModal: any
  sensorBox: any
}

function Sensordatadetailes(props: SensorProps) {

  const [openAccordion, setOpenAccordion] = useState<Array<any>>([]);
  const [currentGraphDataOfTheWeek, setCurrentGraphDataOfTheWeek] = useState<Array<any>>([]);
  const [previousGraphDataOfTheWeek, setPreviousGraphDataOfTheWeek] = useState<Array<any>>([]);
  const [powerConsumptionInfo, setPowerConsumptionInfo] = useState<boolean>(false);
  const [hasCurrent, setHasCurrent] = useState<boolean>(false);
  const [weatherInfo, setWeatherInfo] = useState<Array<any>>([]);
  const [sensorTypeList, setSensorTypeList] = useState<Array<any>>([]);
  const [pinConfigurations, setPinConfigurations] = useState<Array<any>>([]);
  const [externalTemplates, setExternalTemplates] = useState<Array<any>>([]);
  const [temperatureUnit, setTemperatureUnit] = useState<'F' | 'C'>('F');

  const system_id = props.sensorBox?.group === 1 ? props.sensorBox?._id : props.sensorBox?.sensor_box_name;
  const type = props.sensorBox?.group === 1 ? 'group' : 'single';
  const lat = props.sensorBox?.location?.coordinates[0];
  const lon = props.sensorBox?.location?.coordinates[1];

  const hasExternalSensorboxes = () => {
    if (props.sensorBox?.group === 1) {
      return props.sensorBox?.sensorboxes?.some(
        (sensorbox: any) => sensorbox?.sensor_box_source === 'external'
      );
    }
    return props.sensorBox?.sensor_box_source === 'external';
  };

  // Check if sensorbox has any current pin type
  const hasCurrentPinType = () => {
    if (props.sensorBox?.group === 1) {
      // For groups, check all sensorboxes
      return props.sensorBox?.sensorboxes?.some((sensorbox: any) => 
        sensorbox?.sensors?.some((sensor: any) => sensor?.pin_type === "current")
      );
    } else {
      // For single sensorbox, check sensors directly
      return props.sensorBox?.sensors?.some((sensor: any) => sensor?.pin_type === "current");
    }
  };

  useEffect(() => {
    if (!props.show) {
      return;
    }

    const needsExternalTemplates = hasExternalSensorboxes();
    const isExternalSource = props.sensorBox?.sensor_box_source === 'external';
    
    if (!isExternalSource) {
      fetchPowerConsumptionForSystem(system_id, 'weekly', type)
      if (lat && lon) {
        fetchWeatherInfo(lat, lon)
      }else{
        setWeatherInfo([])
      }
    } else {
      setWeatherInfo([])
      setPowerConsumptionInfo(false)
    }

    getSensorTypeList(isExternalSource)

    fetchPinConfigurations()
    
    if (needsExternalTemplates) {
      fetchExternalTemplates()
    }
    
    const hasCurrent = hasCurrentPinType();
    setHasCurrent(hasCurrent)
    
    // Get temperature unit from cache (synchronous)
    if (props.sensorBox?.asset_type) {
      const unit = temperatureService.getTemperatureUnit(props.sensorBox.asset_type);
      setTemperatureUnit(unit);
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.sensorBox, props.show]);

  const fetchPowerConsumptionForSystem = async (id: any, frequencyType?: any, systemType?: any) => {
    try {
      if (id) {
        let powerData = await SensorService.getEnergyGraphData(id ? id : '', frequencyType, systemType)
        const { currentData, previousData, message } = powerData;
        if (message === 'Success') {
          setCurrentGraphDataOfTheWeek(currentData)
          setPreviousGraphDataOfTheWeek(previousData)
          setPowerConsumptionInfo(true)
        } else {
          setPowerConsumptionInfo(false)
        }
      }
    } catch (error) {
      let errMsg = error?.message;
      if (error?.response?.data?.message) {
        errMsg = error?.response?.data?.message
      }
      toast.error(errMsg);
    }
  }

  const fetchWeatherInfo = async (lat: any, lon: any) => {
    try {
      let weatherInfo = await SensorService.getWeather(lat, lon)
      setWeatherInfo(weatherInfo?.weatherInfo)
    } catch (error) {
      let errMsg = error?.message;
      if (error?.response?.data?.message) {
        errMsg = error?.response?.data?.message
      }
      toast.error(errMsg);
    }
  }

  const getSensorTypeList = async(isExternalSource: boolean) => {
      try {
          const sensorBoxSource = isExternalSource ? 'external' : 'internal';
          const sourceType = isExternalSource ? props.sensorBox?.source_type : undefined;
          
          let sensorTypeList = await userService.getSensorTypeList(sensorBoxSource, sourceType)

          setSensorTypeList(sensorTypeList)
      } catch (error) {
          // toast.error(error.response.data.message)
      }
  }

  const fetchPinConfigurations = async () => {
    try {
      const resp = await pinConfigurationService.getPinConfiguration();
      if (resp && resp.data) {
        const { pin_configuration } = resp.data;
        setPinConfigurations(pin_configuration || []);
      }
    } catch (error) {
      // toast.error(error?.response?.data?.message)
    }
  }

  const fetchExternalTemplates = async () => {
    try {
      const templates = await userService.getExternalSensorTemplates();
      setExternalTemplates(templates || []);
    } catch (error) {
      // toast.error(error?.response?.data?.message)
    }
  }

  function SensorDataTable(value: any) {
    let tempSensorTypeList = [];
    let isExternal = value?.sensor_box_source === 'external';
    if(isExternal){
      // Find matching template based on source_type and sensor_box_type
      const matchingTemplate = externalTemplates.find((template: any) => 
        template.source_type === value?.source_type && 
        template.board_category === value?.sensor_box_type
      );
      
      // Match sensors with pin_configurations by type and sub_type
      tempSensorTypeList = value.sensors.map((sensor: any) => {
        const matchingPinConfig = pinConfigurations.find((pinConfig: any) => 
          pinConfig.type === sensor.pin_type && pinConfig.sub_type === sensor.sub_type 
        );
        
        if (matchingPinConfig) {
          return {
            ...sensor,
            display_name: matchingPinConfig.display_name || sensor.sub_type,
            unit: matchingPinConfig.unit || sensor.unit,
            format_type: matchingPinConfig.pin_format_type || sensor.sensor_format_type || sensor.format_type
          };
        }
        
        return {
          ...sensor,
          display_name: sensor.sub_type,
          unit: sensor.unit,
          format_type: sensor.sensor_format_type || sensor.format_type
        };
      });
      
      // Sort sensors based on template config order if template is found
      if (matchingTemplate && matchingTemplate.config) {
        // Expand template config if it's LGMV (has IDU placeholders)
        const iduCount = value?.idu_count || 1;
        const isLgmvTemplate = matchingTemplate.board_category?.toLowerCase() === 'lgmv' || 
                               matchingTemplate.name?.toUpperCase().includes('LGMV');
        
        let expandedConfig: any[] = [];
        if (isLgmvTemplate) {
          // Expand config for LGMV templates
          matchingTemplate.config.forEach((configItem: any) => {
            const hasIduPlaceholder = 
              configItem.sensor_name?.includes('{{ idu_count }}') ||
              configItem.display_name?.includes('{{ idu_count }}') ||
              configItem.external?.field_location?.includes('{{ idu_count }}');
            
            if (hasIduPlaceholder && iduCount > 0) {
              for (let i = 1; i <= iduCount; i++) {
                expandedConfig.push({
                  ...configItem,
                  sensor_name: configItem.sensor_name?.replace(/\{\{\s*idu_count\s*\}\}/g, String(i)),
                  display_name: configItem.display_name?.replace(/\{\{\s*idu_count\s*\}\}/g, String(i)),
                  external: {
                    ...configItem.external,
                    field_location: configItem.external?.field_location?.replace(/\{\{\s*idu_count\s*\}\}/g, String(i)),
                  }
                });
              }
            } else {
              expandedConfig.push(configItem);
            }
          });
        } else {
          expandedConfig = matchingTemplate.config;
        }
        
        // Create a map of sensor_name to config index for ordering
        const configOrderMap = new Map();
        expandedConfig.forEach((configItem: any, index: number) => {
          const sensorName = configItem.sensor_name;
          if (sensorName) {
            configOrderMap.set(sensorName, index);
          }
        });
        
        // Sort tempSensorTypeList based on config order
        tempSensorTypeList.sort((a: any, b: any) => {
          const orderA = configOrderMap.get(a.sensor_name) ?? Infinity;
          const orderB = configOrderMap.get(b.sensor_name) ?? Infinity;
          return orderA - orderB;
        });
      }
    } else {
      tempSensorTypeList = sensorTypeList;
      tempSensorTypeList = sensorTypeList?.map((item: any, index: any) => {
          let pin_order = item.pin_order.find((pin: any) => {
              return pin.board_version === value?.board_version
          })
          return pin_order ? {...item, pinOrder: pin_order?.order} : item 
      }).sort((a: any, b: any) => (a?.pinOrder - b?.pinOrder))
    }

    const orderedSensors = isExternal 
      ? tempSensorTypeList // For external, tempSensorTypeList already contains enriched sensors
      : tempSensorTypeList
          .filter((sensorType: any) => {
            // Check if this sensor exists in props.sensorBox.sensors
            return value.sensors.some(
              (sensor: any) => sensor.sensor_name === sensorType.sensor_name_abbr 
            );
          })
          .map((sensorType: any) => {
            // Find and return the actual sensor object
            return value.sensors.find(
              (sensor: any) => sensor.sensor_name === sensorType.sensor_name_abbr
            );
          });

    return (
      <table className="table sensor-list">
        <thead className="table-header-bg">
          <tr>
            <th className="text-center text-custom-size" scope="col">#</th>
            <th className="text-custom-size custom-width no-wrap" scope="col">Sensor name</th>
            <th className="text-center text-custom-size" scope="col">Sensor Type</th>
            <th className="text-center text-custom-size" scope="col">Parameter value</th>
            <th className="text-center text-custom-size" scope="col">Parameter status</th>
            <th className="text-center text-custom-size" scope="col">Last update</th>
          </tr>
        </thead>
        {
          orderedSensors.map((item: any, index: number) => (
              <tbody className="" key={index}>
                <tr className={index % 2 !== 0 ? "background-color" : ""}  >
                  <th className="text-center text-custom-size" scope="row">{index + 1}</th>
                  <td className="text-custom-size custom-width no-wrap">{item?.display_name || item?.external?.field_name}</td>
                  <td className="text-center text-custom-size">{<img className="guage-icon" src={Utility.getSensorImage(item)} alt='' />} </td>
                  <td className="text-center text-custom-size">{Utility.formatSensorValue(item, value?.asset_type || props.sensorBox?.asset_type)}</td>
                  <td className="text-center">
                    {Utility.checkSensorRange(item) === "nil" ? "-" :
                      <i className={`fa fa-circle ${Utility.checkSensorRange(item)}`} aria-hidden="true"></i>}
                  </td>
                  <td className="text-center text-custom-size">
                    {value?.last_updated_time ?
                      moment(value?.last_updated_time).format('MM/DD/YYYY, HH:mm:ss') : '-'}
                  </td>
                </tr>
              </tbody>
            ))
        }
      </table>

    )
  }

  const currentWeekPower = (currentGraphDataOfTheWeek.reduce((total: any, next: any) => total + next.total_energy_consuption, 0));
  const previousWeekPower = (previousGraphDataOfTheWeek.reduce((total: any, next: any) => total + next.total_energy_consuption, 0));
  const isthisWeekHighestPower = (currentWeekPower > previousWeekPower) ? true : false;

  function powerModal() {
    
    return (
      <>
        <p className="page-title text-left">Power Consumption </p>
        <div className="px-3">
          <Row>
            <Col lg="6" sm="6" className="pl-0">
              <Card className="border">
                <Card.Body>
                  <Row>
                    <Col xs="12">
                      <div className="numbers text-md-center">
                        <Card.Title className="mb-0" as="h4">Last Week (Power) : {hasCurrent ? `${Math.round(previousWeekPower)}kWh` : 'NA'} &nbsp;
                          {hasCurrent && previousWeekPower ? isthisWeekHighestPower ? <img className="mb-2" src={downArrow} height={18} alt='' />
                            : <img className="mb-2" src={upArrow} height={18} alt='' />
                            : hasCurrent ? <img className="mb-2" src={downArrow} height={18} alt='' /> : null
                          }
                        </Card.Title>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col lg="6" sm="6" className="pr-0">
              <Card className="border">
                <Card.Body>
                  <Row>
                    <Col xs="12">
                      <div className="numbers text-md-center">
                        <Card.Title className="mb-0" as="h4">This Week (Power) : {hasCurrent ? `${Math.round(currentWeekPower)}kWh` : 'NA'} &nbsp;
                          {hasCurrent && currentWeekPower ? isthisWeekHighestPower ? <img className="mb-2" src={upArrow} height={18} alt='' />
                            : <img className="mb-2" src={downArrow} height={18} alt='' />
                            : hasCurrent ? <img className="mb-2" src={downArrow} height={18} alt='' /> : null
                          }
                        </Card.Title>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    )
  }

  function weatherModal() {
    return (
      <>
        <p className="page-title text-left">Weather Information </p>
        <div className="px-3">
          <Row>
            <Col lg="6" sm="6" className="pl-0">
              <Card className="border">
                <Card.Body>
                  <Row>
                    <Col xs="12">
                      <div className="numbers text-md-center">
                        <Card.Title className="mb-0" as="h4">
                          Outside Temperature : {(() => {
                            const temp = weatherInfo[0]?.temperature;
                            if (temp === null || temp === undefined) return '--';
                            const converted = temperatureUnit === 'C' 
                              ? temperatureService.convertAndFormat(temp, 'C', 0)
                              : Math.round(temp);
                            return `${converted}°${temperatureUnit}`;
                          })()} &nbsp;
                        </Card.Title>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col lg="6" sm="6" className="pr-0">
              <Card className="border">
                <Card.Body>
                  <Row>
                    <Col xs="12">
                      <div className="numbers text-md-center">
                        <Card.Title className="mb-0" as="h4">Outside Humidity : {Math.round(weatherInfo[0]?.humidity)} % &nbsp;
                        </Card.Title>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    )
  }

  const onClickAccordionHeader = (indexOfHeader: number) => {
    (openAccordion.includes(indexOfHeader)) ?
      setOpenAccordion(openAccordion.filter(index => index !== indexOfHeader))
      : setOpenAccordion(prevState => ([...prevState, indexOfHeader]))
  }

  let filteredSensorBoxesForGroup = props.sensorBox?.sensorboxes?.filter((sensor: any) => sensor.device_type === 'general');
  // Show Power calculation for all asets; except those in "room" asset_type 
  let isRoomAsset = (props.sensorBox?.asset_type && (props.sensorBox?.asset_type === 'room_1rm' || props.sensorBox?.asset_type === 'room_2rm' || props.sensorBox?.asset_type === 'room_4rm')) ? true : false
  
  return (
    <Modal
      show={props.show}
      onHide={props.closeModal}
      size="lg"
    >
      <Modal.Header className="page-title text-left" closeButton>
        <div>{props.sensorBox?.group === 1 ? props.sensorBox.name : props.sensorBox.sensor_box_name} {props.sensorBox.alias && <span className='pl-2'>( {props.sensorBox.alias} )</span>}</div>
      </Modal.Header>
      <Modal.Body>
        {props.sensorBox?.sensor_box_source !== 'external' && weatherInfo?.length > 0 && weatherModal()}
        {props.sensorBox?.sensor_box_source !== 'external' && ((!(props.sensorBox.group) && (props.sensorBox.sensorbox_group)) || isRoomAsset ) ? null : (powerConsumptionInfo && powerModal())}
        <p className="page-title text-left pt-3">Sensor Details</p>
        {props.sensorBox?.group === 1 ?
          filteredSensorBoxesForGroup?.map((item: any, index: number) => {
              return (
                <Accordion key={index} defaultActiveKey={`${index}`} >
                  <Card className="accordion-card">
                    <Accordion.Toggle as={Card.Header}
                      onClick={() => { onClickAccordionHeader(index) }}
                      eventKey={`${index}`} >
                      {item?.sensor_box_name} {item?.alias && (`(${item?.alias})`)}
                      {(openAccordion.includes(index)) ? (
                        <i style={{ fontSize: 12 }} className={'fa fa-chevron-down'} aria-hidden="true"></i>
                      ) : (
                        <i style={{ fontSize: 12 }} className={'fa fa-chevron-up'} aria-hidden="true"></i>
                      )}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={`${index}`}>
                      <Card.Body className="p-0">
                        {item?.sensors?.length > 0 ?
                          SensorDataTable(item)
                          :
                          <div className="text-center w-100 no-card-ph">
                            <div className="no-result-container-text">
                              <p className="no-cards">
                                No sensors added
                              </p>
                            </div>
                          </div>
                        }
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              )
            })
          :
          props.sensorBox?.sensors?.length > 0 ?
            SensorDataTable(props.sensorBox)
            :
            <div className="text-center w-100 no-card-ph">
              <div className="no-result-container-text">
                <p className="no-cards">
                  No sensors added
                </p>
              </div>
            </div>
        }
      </Modal.Body>
    </Modal>
  );
}

export default Sensordatadetailes;